import Vue from 'vue';

/* Form creation & validation */
import VueFormGenerator from 'vue-form-generator';
import 'vue-form-generator/dist/vfg.css';

import FieldArrayLibrary from 'vfg-field-array';
import FieldObjectLibrary from 'vfg-field-object';

/* Cleave lib as dependency for vue-form-generator cleave field */
import 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';

import fieldCurrency from '@/components/custom_fields/general/fieldCurrency';
import fieldDatePicker from '@/components/custom_fields/general/fieldDatePicker';
import fieldFancyCheckbox from '@/components/custom_fields/general/fieldFancyCheckbox';
import fieldFancyChecklist from '@/components/custom_fields/general/fieldFancyChecklist';
import fieldFancyTextArea from '@/components/custom_fields/general/fieldFancyTextArea';
import fieldMultipleCheckbox from '@/components/custom_fields/general/fieldMultipleCheckbox';
import fieldRegex from '@/components/custom_fields/general/fieldRegex';
import fieldSearchMultiSelect from '@/components/custom_fields/general/fieldSearchMultiSelect';
import fieldSmartPassword from '@/components/custom_fields/general/fieldSmartPassword';
import fieldSmartSsn from '@/components/custom_fields/general/fieldSmartSsn';
import fieldSocial from '@/components/custom_fields/general/fieldSocial';
import fieldSplitAddress from '@/components/custom_fields/general/fieldSplitAddress';


/* Vue Form Generator Registration */
Vue.use(VueFormGenerator, {
  validators: {
    // PRICE VALIDATORS min=0, max=100000000
    customDollarValidator: (value) => {
      if (!value) { return null; }
      const errorMessage = 'Please input a dollar amount between $0 and $100,000,000';
      const stringAsFloat = parseFloat(value);
      const valueLengthMax = 9;
      const valueLengthMin = 1;
      const valueStringMax = 100000000;
      const valueStringMin = 0;
      const maxMinLength = (value.length < valueLengthMin || value.length > valueLengthMax);
      const maxMinValue = (stringAsFloat < valueStringMin || stringAsFloat > valueStringMax
        || isNaN(stringAsFloat));

      if (maxMinLength || maxMinValue) {
        return [errorMessage];
      }
      return [];
    },
  },
});

/* Optional Fields Registration */
Vue.use(FieldArrayLibrary);
Vue.use(FieldObjectLibrary);

/* Custom Fields Registration */
Vue.component('fieldCurrency', fieldCurrency);
Vue.component('fieldDatePicker', fieldDatePicker);
Vue.component('fieldSearchMultiSelect', fieldSearchMultiSelect);
Vue.component('fieldSocial', fieldSocial);
Vue.component('fieldMultipleCheckbox', fieldMultipleCheckbox);
Vue.component('fieldFancyCheckbox', fieldFancyCheckbox);
Vue.component('fieldSmartPassword', fieldSmartPassword);
Vue.component('fieldSmartSsn', fieldSmartSsn);
Vue.component('fieldRegex', fieldRegex);
Vue.component('fieldSplitAddress', fieldSplitAddress);
Vue.component('fieldFancyChecklist', fieldFancyChecklist);
Vue.component('fieldFancyTextArea', fieldFancyTextArea);



// WEBPACK FOOTER //
// ./src/start/forms.js